import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { Button } from '@/shared/components/ui/button';
import { Card, CardContent, CardHeader } from '@/shared/components/ui/card';
import { cn } from '@/shared/utils/cn';

type Props = {};

export const UpdatePasswordSuccessMessage = ({}: Props) => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isFromSettings = searchParams.get('from') === 'settings';

  const handleContinue = () => {
    if (isFromSettings) {
      navigate(paths.settings.getHref());
    } else {
      navigate(paths.auth.login.getHref());
    }
  };

  return (
    <Card variant="form">
      <CardHeader>
        <div
          className={cn(
            'mx-auto flex size-[100px] items-center justify-center',
          )}
        >
          <img src="/auth/password_updated_icon.png" />
        </div>
        <h2 className="text-center text-4xl font-medium leading-tight tracking-[0.04em]">
          {t('UpdatePasswordSuccessMessage.title')}
        </h2>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row justify-center gap-10">
          <Button
            variant={'greenGradient'}
            btnType="primary"
            onClick={handleContinue}
          >
            {isFromSettings
              ? t('UpdatePasswordSuccessMessage.back_to_settings_button_label')
              : t('UpdatePasswordSuccessMessage.back_to_login_button_label')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
